export default "__VITE_ASSET__CzlYCxBo__"